// @flow
import { toastr } from 'react-redux-toastr';
import { makeApiCall } from '../apiService/apiService';
import {
  redirectToPath,
  resetCookieAndSession,
  setCookieAndSession
} from '../helpers';
import config from '../../configs/envConfig';
import { PanelConstants } from '../utils';

export const loginServiceActions = {
  GET_OTP: 'GET_OTP',
  SEND_OTP: 'SEND_OTP'
};

export const getOTPAction = (load: Object, action: Object) => ({
  type: action,
  payload: load
});

const FailurePayload = (dispatch, res) => {
  dispatch(
    getOTPAction(
      {
        isLoading: true,
        isLoaded: false,
        submitClicked: false,
        loginClicked: false,
        error: (res && res.errorMessage) || 'Failed to login'
      },
      loginServiceActions.GET_OTP
    )
  );
};

export const resetSubmitClickedValue = () => (dispatch: Function) => {
  dispatch(
    getOTPAction(
      {
        submitClicked: false,
        isLoaded: true,
        error: null
      },
      loginServiceActions.GET_OTP
    )
  );
};

export const getOtpForAuthentication = (params: Object) => (
  dispatch: Function
) => {
  dispatch(
    getOTPAction(
      {
        submitClicked: false,
        isLoaded: true,
        error: null,
        isNewUserRegistration: false
      },
      loginServiceActions.GET_OTP
    )
  );

  const requestObj = {
    baseUrl: 'login',
    apiEndPoint: 'sendOtp',
    contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
    method: 'POST',
    postFormData: true,
    data: params,

    successCb: res => {
      if (res.status === 'SUCCESS' && !res.errorMessage) {
        dispatch(
          getOTPAction(
            {
              submitClicked: true,
              isLoaded: true,
              error: null,
              isNewUserRegistration:
                res.additionalDetails.isNewUserRegistration,
              loginClicked: false
            },
            loginServiceActions.GET_OTP
          )
        );
        resetCookieAndSession();
      } else if (res.status === 'FAILURE') {
        toastr.error('Error', res.errorMessage || 'Failed to login');
        FailurePayload(dispatch, res);
      }
    },
    failureCb: res => {
      toastr.error('Error', 'Failed to login');
      FailurePayload(dispatch, res);
    },
    catchCb: res => {
      toastr.error('Error', 'Failed to login');
      FailurePayload(dispatch, res);
    }
  };

  return makeApiCall(requestObj);
};

export const sendOtpForAuthentication = (params: Object) => (
  dispatch: Function
) => {
  dispatch(
    getOTPAction(
      {
        isLoading: true,
        isLoaded: false,
        dashboardData: [],
        dashboardDataFiltered: [],
        loginClicked: true,
        error: null
      },
      loginServiceActions.GET_OTP
    )
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'verifyOtp',
    method: 'POST',
    data: params,
    successCb: res => {
      if (res.status === 'SUCCESS' && !res.errorMessage) {
        dispatch(
          getOTPAction(
            {
              isLoading: true,
              isLoaded: false
            },
            loginServiceActions.GET_OTP
          )
        );
        // setting access token fetched from the api to cookies
        setCookieAndSession(res.payload);
        redirectToPath(config.baseName + PanelConstants.newPrqPage);
      } else if (res.status === 'FAILURE') {
        FailurePayload(dispatch, res);
      }
    },
    failureCb: res => {
      toastr.error('Error', 'Failed to login');
      FailurePayload(dispatch, res);
    },
    catchCb: res => {
      toastr.error('Error', 'Failed to login');
      FailurePayload(dispatch, res);
    }
  };
  resetCookieAndSession();
  return makeApiCall(requestObj);
};
